import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteEncryptionConfig } from '@/services/encryption/delete-encryption-config';
import { ENCRYPTION_STATUS_QUERY_KEY } from '@/hooks/queries/use-get-encryption-status';

export const useDeleteEncryptionConfig = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => deleteEncryptionConfig(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ENCRYPTION_STATUS_QUERY_KEY],
      });
    },
  });
};
